import { useMutation, useQuery } from "@tanstack/react-query";

import {
  FINAL_PAY_SHIPMENT,
  GET_AMOUNT_TO_PAY_SHIPMENTS,
  GET_COMMISSION_FOR_REFILL,
  GET_PAYMENT_PROVIDERS,
  GET_PAYMENT_URL,
  START_PAY_SHIPMENT_PROCESS,
} from "@/constants/Query";
import { PaymentProvider } from "@/enums";
import { IPaymentProvider } from "@/types/apiResponse.types";
import { apiRequest } from "@/utils/apiRequest";

export const usePaymentProvidersDataRequest = (enabled: boolean) => {
  return useQuery<{
    data: {
      data: IPaymentProvider[];
    };
  }>({
    queryKey: [GET_PAYMENT_PROVIDERS, enabled],
    queryFn: () => apiRequest(GET_PAYMENT_PROVIDERS, "get"),
    enabled,
  });
};

export const useGetPaymentUrlRequest = ({
  totalAmount,
  selectedMethodId,
  enabled,
}: {
  totalAmount: number;
  selectedMethodId: PaymentProvider | "";
  enabled: boolean;
}) => {
  return useQuery<{
    data: {
      data: { urlForPay: string };
    };
  }>({
    queryKey: [GET_PAYMENT_URL, enabled, selectedMethodId, totalAmount],
    queryFn: () =>
      apiRequest(GET_PAYMENT_URL, "get", {
        bankId: selectedMethodId,
        amount: totalAmount,
        // currency: selectedMethodId === PaymentProvider.BOG ? "gel" : "usd",
        currency: "usd",
      }),

    enabled: !!selectedMethodId && enabled,
  });
};

export const usePaymentCommisionDataRequest = ({
  totalAmount,
}: {
  totalAmount: number;
}) => {
  return useQuery<{
    data: {
      data: {
        commissionAmountInNational: number;
        toPayAmountInNational: number;
        toPayAmountInUsd: number;
        commissionAmountInUsd: number;
      };
    };
  }>({
    queryKey: [GET_COMMISSION_FOR_REFILL, totalAmount],
    queryFn: () =>
      apiRequest(GET_COMMISSION_FOR_REFILL, "get", {
        amount: totalAmount,
      }),
    enabled: !!totalAmount,
  });
};

export const useStartPayShipmentProcessRequest = () => {
  return useMutation({
    mutationFn: (selectedOrderIds: number[]) =>
      apiRequest(START_PAY_SHIPMENT_PROCESS, "post", {
        shipmentIds: selectedOrderIds,
      }),
    // onSuccess: async () => {
    //   await finalPayShipmentProcess();
    // },
  });
};

export const useFinalPayShipmentProcessRequest = () => {
  return useMutation({
    mutationFn: () => apiRequest(FINAL_PAY_SHIPMENT, "put"),
  });
};

export const useGetAmountToPayShipments = ({
  shipmentIds,
}: {
  shipmentIds: number[];
}) => {
  return useQuery<{
    data: {
      data: {
        totalPriceForNotPayedInUsd: number;
        commissionAmountInUsd: number;
        totalPriceForNotPayedInNational: number;
        commissionAmountInNational: number;
      };
    };
  }>({
    queryKey: [GET_AMOUNT_TO_PAY_SHIPMENTS, shipmentIds],
    queryFn: () =>
      apiRequest(GET_AMOUNT_TO_PAY_SHIPMENTS, "get", { ids: shipmentIds }),
    enabled: shipmentIds.length > 0,
  });
};
